import { SinglePageLayoutContext } from "layout/SinglePageLayout";
import { useContext, useEffect, useState } from "react";
import Steps from "common/Steps/Steps";
import NavigationButtons from "common/NavigationButtons/NavigationButtons";
import labels from "utils/LocalizedStrings";
import SuccessPopup from "common/SuccessPopup/SuccessPopup";
import { useNavigate } from "react-router-dom";
import Row from "common/Row/Row";
import { useSuspendMonthlyPayoutInfoMutation } from "service/APIService";
import Spinner from "common/Spinner/Spinner";
import ErrorMessage from "common/ErrorMessage/ErrorMessage";
import { amountFormatter, getRequiredIds, scrollToTop } from "utils/Utilities";
import { useSelector } from "react-redux";

const SuspendMonthlyPayout = () => {
  const singlePageLayoutContext = useContext(SinglePageLayoutContext);
  const navigate = useNavigate();
  const participantDetails = useSelector(
    (state) => state?.authReducer?.participantDetails
  );
  const investmentDetails = useSelector(
    (state) => state?.commonReducer?.investmentDetailsInStore
  );

  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors] = useState(null);

  const [suspendMonthlyPayoutApi, { isLoading }] =
    useSuspendMonthlyPayoutInfoMutation();

  const submit = () => {
    setErrors(null);
    scrollToTop();

    const payload = {
      ...getRequiredIds(participantDetails),
    };

    suspendMonthlyPayoutApi(payload)
      .unwrap()
      .then(() => {
        setShowPopup(true);
      })
      .catch((err) => {
        setErrors(err?.data);
      });
  };

  useEffect(() => {
    singlePageLayoutContext({
      id: "suspend-monthly-payout",
      title: labels?.suspendMonthlyPayout?.title,
      buttonText: labels?.suspendMonthlyPayout?.cancel,
      buttonPath: "/dashboard",
      description: "",
      hideCancelModal: true,
    });
  }, []);

  if (investmentDetails?.monthlyPayoutsInfo?.payoutStatusCode === "A")
    return (
      <section className="single-page-container">
        {isLoading && <Spinner />}
        {errors && <ErrorMessage error={errors} />}
        <Steps
          title=""
          description=""
          infoMsg={labels?.suspendMonthlyPayout?.infoMsg}
        />
        <div className="mb-3">
          {labels?.suspendMonthlyPayout?.estimatedPayouts}
        </div>

        <Row
          leftValue={labels?.suspendMonthlyPayout?.estimatedMonthlyPayout}
          leftClass="fw-bold col-7"
          rightValue={amountFormatter(
            investmentDetails?.monthlyPayoutsInfo?.estimatedMonthlyPayout
          )}
          noBorder={true}
        />
        <Row
          leftValue={labels?.suspendMonthlyPayout?.currentWithdrawalPeriod}
          leftClass="fw-bold col-6"
          rightValue={
            investmentDetails?.monthlyPayoutsInfo?.currentWdlPeriodStartDate +
            " - " +
            investmentDetails?.monthlyPayoutsInfo?.currentWdlPeriodEndDate
          }
          noBorder={true}
          wrapperClassNames="mb-3"
        />

        <p className="border-bottom-1 pb-3">
          {labels?.suspendMonthlyPayout?.suspendMsg}
        </p>

        <NavigationButtons
          rightLabel={labels?.suspendMonthlyPayout?.submit}
          rightClick={submit}
          leftClassName="col-4"
          rightClassName="col-4"
        />

        <SuccessPopup
          showModal={showPopup}
          buttonText={labels?.suspendMonthlyPayout?.home}
          body={labels?.suspendMonthlyPayout?.successMsg}
          click={() => navigate("/dashboard")}
        />
      </section>
    );
};

export default SuspendMonthlyPayout;
